<template>
  <v-icon :color="color" :size="size">
    {{ icon }}
  </v-icon>
</template>

<script>
export default {
  name: 'LegendLayerListIcon',
  props: {
    color: {
      type: String,
      required: true,
    },
    layerType: {
      type: String,
    },
    size: {
      type: [Number, String],
      default: '24px',
    },
  },
  computed: {
    icon() {
      if (this.layerType === 'polygon' || this.layerType === 'multipolygon') {
        return 'mdi-square-rounded';
      } else if (this.layerType === 'point' || this.layerType === 'multipoint') {
        return 'mdi-circle-medium';
      } else if (this.layerType === 'linestring' || this.layerType === 'multilinestring') {
        return 'mdi-chart-line-variant';
      } else if (this.layerType === 'xyz' || this.layerType === 'wms' || this.layerType === 'wmts') {
        return 'mdi-earth';
      } else if (this.layerType === 'raster') {
        return 'mdi-checkerboard';
      } else {
        return 'mdi-layers';
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
